import React, { useEffect, useContext, useState } from 'react'

import {BrowserRouter, Route, useLocation} from 'react-router-dom'
import pageRouter from 'pages/page-router';

import SessionContext, { useSession } from 'SessionContext'
import { AppErrorBoundary } from 'partials/error-notifications'

import AuthTokenContext from 'AuthTokenContext'

import { w3cwebsocket as W3CWebSocket } from "websocket";
import { status } from 'hooks/useNotificationsStore';
import { GlobalStateProvider } from "./hooks/useGlobalState";

function Routes() {
    const session = useSession()
    const tokens = useContext(AuthTokenContext)
    const [reconnect, setReconnect] = useState(true)

    const loadChartsDataRef = React.useRef(session.chartsStore.loadChartsData);
    useEffect(() => {
        loadChartsDataRef.current = session.chartsStore.loadChartsData;
    }, [session.chartsStore.loadChartsData]);

    let ws;
    function initializedWebSocket(token, companyId) {
        ws = new W3CWebSocket(window.ws_url)
        let initializeTimeout;

        setReconnect(false)
        const apiCall = {
            token,
            companyId
        };

        ws.onclose = (_event) => {
            clearTimeout(initializeTimeout)
            initializeTimeout = setTimeout(
                () => setReconnect(true), 1000)
        };

        ws.onopen = (_event) => {
            ws.send(JSON.stringify(apiCall));
        };

        ws.onmessage = function (event) {
            const message = JSON.parse(event.data);
            session.notificationsStore.add(message.message, status.complete, message.detail);
            loadChartsDataRef.current();
        };
    }

    useEffect(() => {
        if (session.loaded && reconnect) {
            initializedWebSocket(tokens.accessToken, session.appState.activeCompany.id);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [session.loaded, reconnect]);

    return (
        <SessionContext.Provider value={session}>
            { session.loaded &&
              <AppErrorBoundary>
                <GlobalStateProvider>
                  <BrowserRouter>
                      <RouteChangeListener />
                      <Route path="/:page?/:subpage?" component={pageRouter} />
                  </BrowserRouter>
                </GlobalStateProvider>
              </AppErrorBoundary>
            }
        </SessionContext.Provider>
    );
}

export default Routes;

/* Deal with stale data when switching explorers */
function RouteChangeListener() {
  const location = useLocation();
  const session = useContext(SessionContext);

  useEffect(() => {
    if(location.pathname === "/admin-user-role-form" ||
       location.pathname === "/admin-user-roles" 
    ) {
        session.appState.refreshIdentity();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return null;
}
